interface Colors {
  white: string;
  black: string;
  lightGrey: string;
  mediumOrange: string;
  lightLightOrange: string;
  grey: string;
  mediumGrey: string;
  darkGrey: string;
  mediumDarkGrey: string;
  yellow: string;
  green: string;
  fuschia: string;
  darkBlue: string;
  babyBlue: string;
  skyBlue: string;
  lightSkyBlue: string;
  whiteSkyBlue: string;
  pink: string;
  babyPink: string;
  orange: string;
  blue: string;
  lightPink: string;
  lime: string;
  lightBlue: string;
  validationError: string;
  purple: string;
  lightPurple: string;
  lightLightPurple: string;
  lightPurple4D: string;
  primary: string;
  secondary: string;
}

const colors: Colors = {
  white: "#ffffff",
  black: "#06050a",
  lightGrey: "#f9f9f9",
  mediumOrange: "#ED6C02",
  lightLightOrange: "#f5f4f2",
  grey: "#C1BFBF",
  mediumGrey: "#9F9F9F",
  darkGrey: "#404040",
  mediumDarkGrey: "#666666",
  yellow: "#fff700",
  green: "#14C532",
  fuschia: "#FF00A1",
  darkBlue: "#071A48",
  babyBlue: "#8FCEFF",
  skyBlue: "#1976d2",
  lightSkyBlue: "#e3f2fd",
  whiteSkyBlue: "#f5f9ff",
  pink: "#FF9FDC",
  babyPink: "#ffe4f2",
  orange: "#ffa500",
  blue: "#1a0dab",
  lightPink: "#fff8fc",
  lime: "#a0ff8f",
  lightBlue: "#f5fbff",
  validationError: "#d32f2f",
  purple: "#600ADD",
  lightPurple: "#8B5CF6",
  lightLightPurple: "#f5f3ff",
  lightPurple4D: "#600ADD4D",
  primary: "#FF5E1F",
  secondary: "#111111",
};

export default colors; 